<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-flex xs12 style="position: relative; flex-basis: auto">
        <v-text-field
          placeholder="Cautare"
          hint="Se cauta dupa id_scoala, adresa, observatii adresa si observatii"
          clearable
          persistent-hint
          append-icon="mdi-magnify"
          solo
          :loading="loading"
          single-line
          @click:append="_cbSearch"
          @keydown.enter="_cbSearch"
          :suffix="String(total)"
          v-model="searchTerm">
        </v-text-field>
      </v-flex>
      <v-flex xs12>
        <split-pane :min-percent="10" :default-percent="50" split="vertical">
          <template slot="paneL">
            <v-card style="display: flex; flex-direction: column; height: 100%">
              <v-card-title>
                <div style="display: flex; flex-direction: column; flex-grow: 1">
                  <div style="display: flex; flex-grow: 1; align-items: center; justify-content: space-between">

                    <span key="title" style="flex-grow: 1">Simboluri</span>

                    <div key="toolbar" style="flex-grow: 1">

                      <v-avatar size="18" class="ma-1" @click="toggleDone" key="toggle-done" :title="done === null ? 'Done si Not Done' : (done === 1 ? 'Done' : 'Not Done')">
                        <v-icon :color="doneColor" :size="20">
                          {{done === null ? 'mdi-check-circle-outline' : (done === 1 ? 'mdi-check-circle' : 'mdi-close-circle')}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="ma-1" @click="toggleEdited" key="toggle-edited" :title="edited === null ? 'Editate si Needitate' : (edited === 1 ? 'Editate' : 'Needitate')">
                        <v-icon :color="editedColor" :size="20">
                          {{edited === null ? 'mdi-pencil-outline' : (edited === 1 ? 'mdi-pencil' : 'mdi-pencil-off')}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="ma-1" @click="togglePhotos" key="toggle-photos" :title="photos === null ? 'Cu si Fara Poze' : (photos === 1 ? 'Cu Poze' : 'Fara Poze')">
                        <v-icon :color="photosColor" :size="20">
                          {{photos === null ? 'mdi-camera-outline' : (photos === 1 ? 'mdi-camera' : 'mdi-camera-off')}}
                        </v-icon>
                      </v-avatar>

                      <!-- <v-avatar size="18" class="ma-1" @click="togglePdfs" key="toggle-pdfs" :title="pdfs === null ? 'Cu si Fara Pdf-uri' : (pdfs === 1 ? 'Cu Pdf-uri' : 'Fara Pdf-uri')">
                        <v-icon :color="pdfsColor" :size="20">
                          {{pdfs === null ? 'mdi-file-pdf-outline' : (pdfs === 1 ? 'mdi-file-pdf' : 'mdi-file-pdf')}}
                        </v-icon>
                      </v-avatar> -->
                    </div>

                    <!-- <v-divider vertical dark key="div-3"></v-divider> -->

                    <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap;" key="deleteSimbols">
                      <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeleteSymbols" v-if="deleteSymbolsEnabled && toDeleteSymbols.length" key="confirm" title="Sterge simbolurile selectate">
                        <v-icon :size="20" color="error">mdi-check-circle</v-icon>
                      </v-btn>
                      <span v-if="deleteSymbolsEnabled && toDeleteSymbols.length" key="todeletelen">
                        {{toDeleteSymbols.length}}
                      </span>
                      <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode('symbol')" key="delete" :title="deleteSymbolsEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                        <v-icon :size="20" :color="deleteSymbolsEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                      </v-btn>
                    </div>

                    <!-- <v-divider vertical dark key="div-1"></v-divider> -->

                    <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap" key="download">
                      <v-btn class="ma-0" icon @click="uplaodXLSX" color="primary" flat key="xlsx-up" title="Upload simboluri din xlsx">
                        <v-icon :size="20">mdi-file-upload</v-icon>
                      </v-btn>
                      <!-- <v-divider vertical dark key="div-2"></v-divider> -->
                      <v-btn class="ma-0" icon @click="downloadXLSX(false)" color="primary" flat key="xlsx-down" :loading="downloading" :disabled="downloading" title="Descarca xlsx cu TOATE simbolurile (tinand cont de eticheta si zona)">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadXLSX(true)" color="accent" flat key="xlsx-down-f" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx DOAR cu simbolurile afisate (${items.length} simboluri)`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadRaport2" color="blue" flat key="xlsx-down-rap2" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx pt verificare autor poze`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadRaportDuplicat" color="yellow" flat key="xlsx-down-rap3" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx cu poze duplicat (tinand cont de filtre). DO NOT FEED IT TOO MAHY THINGS AT ONCE! You have been warned.`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn v-if="tab === 'photos'" class="ma-0" icon flat @click="download('symbols')" key="downloadbtn" :title="`Descarca pozele simbolurilor afisate (grupate pe foldere) - ${items.length} simboluri`">
                        <v-icon :size="20" color="accent">mdi-package-down</v-icon>
                      </v-btn>
                      <v-btn v-if="tab === 'pdfs'" class="ma-0" icon flat @click="downloadPdfs('grouped')" key="downloadpdfsbtn" :title="`Descarca pdf-urile simbolurilor afisate (grupate pe foldere) - ${items.length} simboluri`">
                        <v-icon :size="20" color="accent">mdi-package-down</v-icon>
                      </v-btn>
                      <span key="downaloadocunt">{{selectedItems.length || items.length}}</span>
                    </div>

                  </div>

                  <v-layout column>
                    <v-flex>
                      Eticheta:
                      <v-chip color="primary" @click="openLabelsDialog" close @input="resetLabel" outline small>
                        <v-icon :size="14">mdi-filter</v-icon>
                        {{ selectedLabel === null ? 'Toate' : (selectedLabel === undefined ? 'Undefined' : selectedLabel) }}
                      </v-chip>
                    </v-flex>
                    <v-flex>
                      Zona:
                      <v-chip color="primary" @click="openZonesDialog" close @input="resetZona" outline small>
                        <v-icon :size="14">mdi-filter</v-icon>
                        {{ selectedZona === null ? 'Toate' : (selectedZona === undefined ? 'Undefined' : selectedZona) }}
                      </v-chip>
                    </v-flex>
                  </v-layout>

                  <v-layout column>
                    <v-flex>
                      Data inceput

                      <v-menu
                        v-model="data_inceput_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        :transition="false"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip color="primary" v-on="on" @input="resetData('Inceput')" close outline small>
                            <v-icon :size="14">mdi-filter</v-icon>
                            {{ dataInceput | dateFormat }}
                          </v-chip>
                        </template>
                        <v-date-picker v-model="dataInceput" @input="data_inceput_menu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex>
                      Data sfarsit

                      <v-menu
                        v-model="data_sfarsit_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        :transition="false"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip color="primary" v-on="on" @input="resetData('Sfarsit')" close outline small>
                            <v-icon :size="14">mdi-filter</v-icon>
                            {{ dataSfarsit | dateFormat }}
                          </v-chip>
                        </template>
                        <v-date-picker v-model="dataSfarsit" @input="data_sfarsit_menu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <v-text-field
                    v-model.number="perPage"
                    hide-details
                    type="number"
                    min="1"
                    flat
                    suffix="pe pagina"
                    single-line>
                  </v-text-field>
                </div>
              </v-card-title>
              <v-card-text style="flex-grow: 1; display: flex; flex-wrap: wrap; overflow-y: auto" class="pa-0">
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; flex-grow: 1; align-content: flex-start">
                  <template v-for="item in items">
                    <div :key="item._id" style="display: flex; flex-direction: column; align-items: center; flex-grow: 0;">
                      <v-avatar
                        style="cursor: pointer"
                        size="48"
                        class="ma-2 symbol"
                        :class="{
                          'selected-symbol': isSelectedItem(item),
                          'delete-enabled': deleteSymbolsEnabled,
                          'toDelete opacity1': toDeleteSymbols.includes(item._id),
                          'opacity1': !deleteSymbolsEnabled && isSelectedItem(item)
                        }"
                        tile
                        @click="_cbSelectDeleteSymbolProxy(item)">
                        <v-img :src="getSrc(item)">
                        </v-img>
                      </v-avatar>
                      <span
                        :key="item._id"
                        class="caption px-1"
                        :class="{
                          'blue-grey--text': !deleteSymbolsEnabled,
                          'primary--text font-weight-bold opacity1': !deleteSymbolsEnabled && selectedItems.length && isSelectedItem(item),
                          'error--text': deleteSymbolsEnabled,
                          'font-weight-bold opacity1': toDeleteSymbols.includes(item._id)
                        }">
                        {{item.id_scoala}}
                        (
                          {{item.photos.length}}
                          <v-icon :size="12" color="blue-grey">mdi-camera</v-icon>
                          <!-- &amp;
                          {{item.pdfs.length}}
                          <v-icon :size="12" color="blue-grey">mdi-file-pdf</v-icon> -->
                        )
                        <br>
                        <v-icon :size="12" color="blue-grey">mdi-update</v-icon>
                        {{item.updatedAt | dateFormat}}
                      </span>
                    </div>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions style="text-align: center; overflow-x: auto; flex: 0 0 64px" class="pa-0">
                <v-spacer></v-spacer>
                <v-pagination
                  style="justify-content: center"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="5"
                  circle
                ></v-pagination>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </template>
          <template slot="paneR">
            <split-pane :min-percent="10" :default-percent="20" split="horizontal">
              <template slot="paneL">
                <v-card style="display: flex; flex-direction: column; height: 100%">
                  <v-card-title style="flex-direction: column; align-items: stretch; ">
                    <div style="height: 28px; display: flex; align-items: center; flex-grow: 1">
                      <span>Galerie ({{selectedItems.length || items.length}} simboluri {{ selectedItems.length ? ' selectate' : 'pe pagina' }})</span>

                      <!-- <v-scale-transition appear> -->
                        <v-btn icon small v-if="selectedItems.length" class="ma-0 ml-1" title="Deselecteaza toate simbolurile" @click="clearSelected">
                          <v-icon small color="error">mdi-close</v-icon>
                        </v-btn>
                      <!-- </v-scale-transition> -->
                      <v-spacer></v-spacer>

                      <!-- <v-btn small icon @click="toggleTab">
                        <v-icon small :color="tab === 'photos' ? 'primary' : 'blue-grey'">mdi-camera</v-icon>
                      </v-btn> -->
                      <!-- <v-btn small icon @click="toggleTab">
                        <v-icon small :color="tab === 'pdfs' ? 'primary' : 'blue-grey'">mdi-file-pdf</v-icon>
                      </v-btn> -->

                      <v-spacer></v-spacer>
                      <v-menu offset-y :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <v-btn small icon v-on="on" title="Selecteaza tipul de poze vizibile">
                            <v-icon small color="primary">mdi-camera-burst</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-switch v-model="tipPoze" value="scoala"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>Scoala</v-list-tile-title>
                          </v-list-tile>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-switch v-model="tipPoze" value="bad photos"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>
                              Bad photos only!
                              <v-icon color="warning" small>mdi-alert</v-icon>
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                      <v-spacer></v-spacer>

                      <!-- <v-scale-transition appear group> -->
                        <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-if="deleteEnabled && toDelete.length" key="confirm" title="Sterge pozele selectate">
                          <v-icon color="error">mdi-check-circle</v-icon>
                        </v-btn>
                        <span v-show="deleteEnabled && toDelete.length" key="todeletelen">
                          {{toDelete.length}}
                        </span>
                        <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode('photo')" key="delete" :title="deleteEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                          <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                        </v-btn>
                      <!-- </v-scale-transition> -->
                      <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap;" key="download">
                        <v-btn v-if="tab === 'photos'" class="ma-0" icon flat @click="download('photos')" key="downloadbtn" :disabled="!visiblePhotosCount" :title="`Descarca pozele afisate (fara grupare pe foldere) - ${items.length} simboluri`">
                          <v-icon color="accent">mdi-package-down</v-icon>
                          <span>{{visiblePhotosCount}}</span>
                        </v-btn>
                        <v-btn v-if="tab === 'pdfs'" class="ma-0" icon flat @click="downloadPdfs('simple')" key="downloadpdfsbtn" :disabled="!visiblePdfsCount" :title="`Descarca pdf-urile afisate (fara grupare pe foldere) - ${items.length} simboluri`">
                          <v-icon color="accent">mdi-package-down</v-icon>
                          <span>{{visiblePdfsCount}}</span>
                        </v-btn>
                      </div>
                    </div>
                    <v-progress-linear height="18" color="accent" class="my-0 mt-2" :value="info.usedPercentage" v-if="info.freeGb" style="text-align: center">
                       <div class="pl-2 white--text" style="display: flex; align-items: center; justify-content: space-around; height: 100%">
                        <v-icon small color="white" >mdi-server-network</v-icon>
                        {{ info.freeGb }}GB liberi din {{ info.totalGb }}GB
                        <span>
                          (
                          <v-icon small color="white" >mdi-image</v-icon>
                          {{ info.photos }}B
                          )
                        </span>
                        <v-icon small color="white" @click="refreshInfo">mdi-refresh</v-icon>
                       </div>
                    </v-progress-linear>
                  </v-card-title>
                  <v-card-text style="display: flex; flex-wrap: wrap; overflow-y: auto" class="pa-0">
                    <template v-if="tab === 'photos'">
                      <template v-if="selectedItems.length">
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in selectedItems">
                            <template v-for="(photo, index) in item.photos">
                              <div
                                v-if="tipPoze.includes(photo.split('_')[1]) && showIfBadPhoto(photo)"
                                :key="item._id + 'photo' + index"
                                class="ma-1"
                                style="display: flex; flex-direction: column; align-items: center"
                                @click="_cbSelectDeletePhotoProxy(item._id, photo)">
                                <v-img
                                  :key="item._id + '_' + index"
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  :lazy-src="serverURL + photo.replace('photos', 'thumbs')"
                                  class="pa-1 ma-1 photo"
                                  :class="{
                                    'selected-photo': selectedPhoto && selectedPhoto.photo === photo,
                                    'toDelete': isToDelete(photo),
                                    'delete-enabled': deleteEnabled
                                  }">
                                    <template v-slot:placeholder>
                                      <v-layout
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0>
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                      </v-layout>
                                    </template>
                                </v-img>
                                <span
                                  style="max-width: 72px; overflow: hidden; word-break: break-all; text-align: center"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{item.id_scoala}}_{{photo.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                  <v-icon small color="warning" v-if="photo.includes('_badphoto')" title="Poza marcata de user ca fiind necorespunzatoare">mdi-alert</v-icon>
                                  <a :href="serverURL + photo" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                    <v-icon small :color="selectedPhoto && selectedPhoto.photo === photo ?  'primary' : 'blue-grey'">mdi-download</v-icon>
                                  </a>
                                </span>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in items">
                            <template v-for="(photo, index) in item.photos">
                              <div
                                v-if="tipPoze.includes(photo.split('_')[1]) && showIfBadPhoto(photo)"
                                :key="item._id + 'photo' + index"
                                class="ma-1"
                                style="display: flex; flex-direction: column; align-items: center"
                                @click="_cbSelectDeletePhotoProxy(item._id, photo)"
                                >
                                <img
                                  :key="item._id + '_' + index"
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  class="pa-1 ma-1 photo"
                                  :class="{
                                    'selected-photo': selectedPhoto && selectedPhoto.photo === photo,
                                    'toDelete': isToDelete(photo),
                                    'delete-enabled': deleteEnabled
                                  }">
                                <span
                                  style="max-width: 72px; overflow: hidden; word-break: break-all; text-align: center"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{item.id_scoala}}_{{photo.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                  <v-icon small color="warning" v-if="photo.includes('_badphoto')" title="Poza marcata de user ca fiind necorespunzatoare">mdi-alert</v-icon>
                                  <a :href="serverURL + photo" download target="_blank" style="text-decoration: none">
                                    <v-icon small :color="selectedPhoto && selectedPhoto.photo === photo ? 'primary' : 'blue-grey'">mdi-download</v-icon>
                                  </a>
                                </span>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                    </template>

                    <template v-else>
                      <template v-if="selectedItems.length">
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in selectedItems">
                            <div
                              :key="item._id + 'pdf' + index"
                              class="ma-1"
                              style="display: flex; flex-direction: column; align-items: center"
                              @click="_cbSelectDeletePdfProxy(item._id, pdf)"
                              v-for="(pdf, index) in item.pdfs">
                              <v-avatar
                                :color="toDelete.includes(pdf) ? 'error' : ''"
                                size="48"
                                class="ma-1"
                                :class="{
                                  'selected-photo': selectedPdf && selectedPdf.pdf === pdf && !deleteEnabled,
                                  'toDelete': isToDelete(pdf),
                                  'delete-enabled': deleteEnabled
                                }"
                                style="box-sizing: border-box">
                                <v-icon class="pa-1">
                                  mdi-file-pdf
                                </v-icon>
                              </v-avatar>
                              <span
                                :key="item._id + '_' + index + 'simbol'"
                                :class="{
                                  'blue-grey--text': !deleteEnabled,
                                  'primary--text font-weight-bold': !deleteEnabled && selectedPdf && selectedPdf.pdf === pdf,
                                  'error--text': deleteEnabled,
                                  'font-weight-bold': isToDelete(pdf)
                                }">
                                {{item.id_scoala}}_{{pdf.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                <a :href="serverURL + pdf" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                                  <v-icon small :color="selectedPdf && selectedPdf.pdf === pdf ?  'primary' : 'blue-grey'">mdi-download</v-icon>
                                </a>
                              </span>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in items">
                            <div
                              :key="item._id + 'photo' + index"
                              class="ma-1"
                              style="display: flex; flex-direction: column; align-items: center"
                              @click="_cbSelectDeletePdfProxy(item._id, pdf)"
                              v-for="(pdf, index) in item.pdfs">
                              <v-avatar
                                :color="toDelete.includes(pdf) ? 'error' : ''"
                                size="48"
                                class="ma-1"
                                :class="{
                                  'selected-photo': selectedPdf && selectedPdf.pdf === pdf && !deleteEnabled,
                                  'toDelete': isToDelete(pdf),
                                  'delete-enabled': deleteEnabled
                                }"
                                style="box-sizing: border-box">
                                <v-icon class="pa-1">
                                  mdi-file-pdf
                                </v-icon>
                              </v-avatar>
                              <span
                                :key="item._id + '_' + index + 'simbol'"
                                :class="{
                                  'blue-grey--text': !deleteEnabled,
                                  'primary--text font-weight-bold': !deleteEnabled && selectedPdf && selectedPdf.pdf === pdf,
                                  'error--text': deleteEnabled,
                                  'font-weight-bold': isToDelete(pdf)
                                }">
                                {{item.id_scoala}}_{{pdf.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                <a :href="serverURL + pdf" download target="_blank" style="text-decoration: none">
                                  <v-icon small :color="selectedPdf && selectedPdf.pdf === pdf ? 'primary' : 'blue-grey'">mdi-download</v-icon>
                                </a>
                              </span>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </template>
              <template slot="paneR">
                <v-card style="display: flex; flex-direction: column; height: 100%">
                  <v-card-title>
                    <div style="height: 28px; display: flex; align-items: center">
                      <span>Preview</span>
                      <template v-if="selectedPhoto && tab === 'photos'">
                        <v-btn icon small class="ma-0 ml-1" @click="zoom(1)" key="zoomin">
                          <v-icon small color="primary">mdi-plus</v-icon>
                        </v-btn>
                        <v-btn icon small class="ma-0 ml-1" @click="zoom(-1)" key="zoomout">
                          <v-icon small color="primary">mdi-minus</v-icon>
                        </v-btn>
                        <span class="caption" key="explanation"> (also ctrl + scroll)</span>
                        <v-btn icon small class="ma-0 ml-1" @click="savePhoto" key="save">
                          <v-icon small color="primary">mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </div>
                  </v-card-title>
                  <v-card-text class="pa-0" style="overflow-x: auto; height: 100%; width: 100%">
                    <dir id="editor" style="height: 100%; overflow-x: auto" ref="editor" @wheel.ctrl.prevent="zoom($event.deltaY * -1)" v-show="tab === 'photos'"></dir>
                    <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="95%" v-if="tab === 'pdfs'"></iframe>
                  </v-card-text>
                </v-card>
              </template>
            </split-pane>
          </template>
        </split-pane>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Incarcare XLSX cu simboluri</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="label"
            label="Eticheta"
            hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate">
          </v-text-field>
          <form ref="form">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading">Renunta</v-btn>
          <v-btn flat color="primary" @click="filesAdded" :loading="uploading" :disabled="uploading">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="labelsDialog" max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa eticheta</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedLabel">
            <v-radio
              v-for="label in labels"
              :key="label.label + label.data"
              :label="`${label.label} (${label.data})`"
              :value="label.label"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="closeLabelsDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="zonesDialog" max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa zona</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedZona">
            <v-radio
              v-for="zona in zones"
              :key="zona.zona"
              :label="zona.zona || 'Toate'"
              :value="zona.zona"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="closeZonesDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Bancul cu iepurasul care vrea sa faca clatite
import { createWriteStream } from 'streamsaver'

import slug from 'slug'

import splitPane from 'vue-splitpane'

import 'tui-image-editor/dist/tui-image-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'
import 'tui-image-editor/dist/svg/icon-a.svg'
import 'tui-image-editor/dist/svg/icon-b.svg'
import 'tui-image-editor/dist/svg/icon-c.svg'
import 'tui-image-editor/dist/svg/icon-d.svg'

const ImageEditor = require('tui-image-editor')

export default {
  name: 'dasboard',
  components: {
    'split-pane': splitPane
  },
  data: () => ({
    tipPoze: ['scoala'],
    search: '',
    selectedItems: [],
    selectedPhoto: null,
    selectedPdf: null,
    editor: null,
    zoomSizes: { width: 0, height: 0 },
    toDelete: [],
    toDeleteSymbols: [],
    deleteEnabled: false,
    deleteSymbolsEnabled: false,
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    zonesDialog: false,
    downloading: false,
    tab: 'photos',
    pdfFrameTitle: '',
    pdfFrameSrc: '',
    data_inceput_menu: false,
    data_sfarsit_menu: false
  }),
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : 'nimic selectat'
    }
  },
  computed: {
    visiblePhotosCount () {
      return this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.photos.length), 0)
    },
    visiblePdfsCount () {
      return this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.pdfs.length), 0)
    },
    serverURL () {
      return this.$store.getters.serverURL
    },
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters['entities/items']
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    perPage: {
      get () {
        return this.$store.getters['entities/perPage']
      },
      set (value) {
        if (value <= 0) value = 10
        this.$store.dispatch('entities/setPerPage', value)
      }
    },
    total () {
      return this.$store.getters['entities/total']
    },
    totalPages () {
      return this.perPage ? Math.ceil(this.total / this.perPage) : 0
    },
    done () {
      return this.$store.getters['entities/done']
    },
    edited () {
      return this.$store.getters['entities/edited']
    },
    photos () {
      return this.$store.getters['entities/photos']
    },
    pdfs () {
      return this.$store.getters['entities/pdfs']
    },
    doneColor () {
      if (this.done === 1) return 'primary'
      if (this.done === -1) return 'error'
      return 'blue-grey'
    },
    editedColor () {
      if (this.edited === 1) return 'primary'
      if (this.edited === -1) return 'error'
      return 'blue-grey'
    },
    photosColor () {
      if (this.photos === 1) return 'primary'
      if (this.photos === -1) return 'error'
      return 'blue-grey'
    },
    pdfsColor () {
      if (this.pdfs === 1) return 'primary'
      if (this.pdfs === -1) return 'error'
      return 'blue-grey'
    },
    info () {
      return this.$store.getters.info
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    selectedLabel: {
      get () {
        return this.$store.getters['entities/selectedLabel']
      },
      set (value) {
        this.$store.commit('entities/setSelectedLabel', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    selectedZona: {
      get () {
        return this.$store.getters['entities/selectedZona']
      },
      set (value) {
        this.$store.commit('entities/setSelectedZona', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    token () {
      return this.$store.getters.token
    },

    dataInceput: {
      get () {
        return this.$store.getters['entities/dataInceput']
      },
      set (value) {
        this.$store.commit('entities/setDataInceput', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    dataSfarsit: {
      get () {
        return this.$store.getters['entities/dataSfarsit']
      },
      set (value) {
        this.$store.commit('entities/setDataSfarsit', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    }
  },
  methods: {
    downloadRaportDuplicat () {
      let filtersQuery = 'filters=nope'

      const filters = {
        done: this.done,
        edited: this.edited,
        photos: this.photos,
        pdfs: this.pdfs,
        page: this.page,
        perPage: this.perPage,
        search: this.searchTerm,
        datainceput: this.dataInceput,
        datasfarsit: this.dataSfarsit
      }
      filtersQuery = new URLSearchParams(filters).toString()

      this.downloading = true
      fetch(`${this.serverURL}/raport3?label=${this.selectedLabel}&zona=${this.selectedZona}&${filtersQuery}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'VerdeScoli_Poze_Identice.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    downloadRaport2 () {
      this.downloading = true
      fetch(`${this.serverURL}/raport2`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'VerdeScoli_Poze_User_size.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    downloadXLSX (filters) {
      let filtersQuery = 'filters=nope'
      if (filters) {
        const filters = {
          done: this.done,
          edited: this.edited,
          photos: this.photos,
          pdfs: this.pdfs,
          page: this.page,
          perPage: this.perPage,
          search: this.searchTerm,
          datainceput: this.dataInceput,
          datasfarsit: this.dataSfarsit
        }
        filtersQuery = new URLSearchParams(filters).toString()
      }

      this.downloading = true
      fetch(`${this.serverURL}/raport?label=${this.selectedLabel}&zona=${this.selectedZona}&${filtersQuery}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = `VerdeScoli_${this.selectedLabel ? slug(this.selectedLabel) : 'Toate'}_${filters ? 'Vizibile' : 'Toate'}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.xlsx`
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    resetLabel () {
      this.selectedLabel = null
    },
    resetZona () {
      this.selectedZona = null
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    openZonesDialog () {
      this.zonesDialog = true
    },
    closeZonesDialog () {
      this.zonesDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    refreshInfo () {
      this.$store.dispatch('getInfo')
    },
    isToDelete (file) {
      return this.toDelete.includes(file)
    },
    _cbConfirmDeleteSymbols () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDeleteSymbols.length} simboluri si pozele aferente! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          this.selectedItems = this.selectedItems.filter(item => !this.toDeleteSymbols.includes(item._id))
          this.$store.dispatch('entities/deleteEntities', this.toDeleteSymbols)
          this.toDeleteSymbols = []
        })
        .catch(() => {})
    },
    _cbSelectDeleteSymbolProxy (item) {
      if (this.deleteSymbolsEnabled) {
        const index = this.toDeleteSymbols.findIndex(simbol => simbol === item._id)
        if (index > -1) this.toDeleteSymbols.splice(index, 1)
        else this.toDeleteSymbols.push(item._id)
      } else {
        this.setSelectedItem(item)
      }
    },
    _cbSelectDeletePhotoProxy (itemId, photo) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === photo)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(photo)
      } else {
        this.setSelectedPhoto(itemId, photo)
      }
    },
    _cbToggleDeleteMode (type) {
      if (type === 'photo') {
        this.deleteEnabled = !this.deleteEnabled
        this.toDelete = []
      } else {
        this.deleteSymbolsEnabled = !this.deleteSymbolsEnabled
        this.toDeleteSymbols = []
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDelete.length} poze! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          const photos = this.toDelete.filter(item => item.startsWith('/photos/'))
          const pdfs = this.toDelete.filter(item => item.startsWith('/pdfs/'))

          if (photos.length) {
            this.$store.dispatch('entities/deletePhotos', { entity: this.deleteEntity, photos })
          }
          if (pdfs.length) {
            this.$store.dispatch('entities/deletePdfs', { entity: this.deleteEntity, pdfs })
          }

          this.selectedItems.forEach(item => {
            item.photos = item.photos.filter(photo => !this.toDelete.includes(photo))
            item.pdfs = item.pdfs.filter(pdf => !this.toDelete.includes(pdf))
          })
          this.toDelete = []
        })
        .catch(() => {})
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    isSelectedItem (item) {
      return !!this.selectedItems.find(sItem => sItem._id === item._id)
    },
    toggleDone () {
      this.$store.dispatch('entities/toggleDone')
    },
    toggleEdited () {
      this.$store.dispatch('entities/toggleEdited')
    },
    togglePhotos () {
      this.$store.dispatch('entities/togglePhotos')
    },
    togglePdfs () {
      this.$store.dispatch('entities/togglePdfs')
    },
    toggleFilter (filter) {
      this.$store.dispatch('entities/toggleFilter', filter)
    },
    getSrc (marker) {
      if (marker.addedBy) {
        if (marker.done) return '/svg/done_people.svg'
        return marker.user ? '/svg/edited_people.svg' : '/svg/unedited_people.svg'
      } else {
        if (marker.done) return '/svg/done.svg'
        return marker.user ? '/svg/edited.svg' : '/svg/unedited.svg'
      }
    },
    setSelectedItem (item) {
      if (this.isSelectedItem(item)) {
        this.selectedItems = this.selectedItems.filter(sItem => sItem._id !== item._id)
      } else {
        this.selectedItems.push(item)
        this.selectedItems = this.selectedItems.sort((a, b) => a.id_scoala.localeCompare(b.id_scoala))
      }
    },
    setSelectedPhoto (itemId, photo) {
      this.selectedPhoto = {
        id: itemId,
        photo
      }

      const canvasSize = this.editor.getCanvasSize()
      const width = this.$refs.editor.scrollWidth
      const height = this.$refs.editor.scrollHeight

      this.editor.loadImageFromURL(this.serverURL + photo, photo).then(result => {
        const { newWidth, newHeight } = result
        const ratio = newWidth / newHeight

        this.editor.ui.resizeEditor({
          imageSize: result,
          uiSize: { width, height }
        })

        if (this.zoomSizes.width) {
          canvasSize.width = this.zoomSizes.width
          canvasSize.height = width / ratio
        } else {
          canvasSize.width = width
          canvasSize.height = width / ratio
        }
        this.editor.resizeCanvasDimension(canvasSize)

        this.zoomSizes = canvasSize
        this.editor.clearRedoStack()
        this.editor.clearUndoStack()
        // w = r * h
        // h = w / r
      })
    },
    clearSelected () {
      this.selectedItems = []
    },
    zoom (dir) {
      const canvasSize = this.zoomSizes
      const ratio = canvasSize.width / canvasSize.height
      const width = canvasSize.width * (dir > 0 ? 1.1 : 0.9)
      if (width > 0) {
        const height = width / ratio
        this.editor.resizeCanvasDimension({ width, height })
        this.zoomSizes = { width, height }
      }
    },
    savePhoto () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Operatie ireversibila. Confirmi operatia?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          const options = {
            format: 'jpeg',
            quality: 1
          }
          const newImage = this.editor.toDataURL(options)
          // console.log(newImage)
          this.$store.dispatch('entities/saveEditedPhoto', { ...this.selectedPhoto, newImage, parent: this.selectedPhoto.photo.split('_')[1] })
            .then(response => {
              this.editor.clearRedoStack()
              this.editor.clearUndoStack()
              const index = this.selectedItems.findIndex(item => item._id === response._id)
              if (index > -1) this.selectedItems.splice(index, 1, response)

              this.selectedPhoto = null
              this.editor.loadImageFromURL(this.serverURL + '/img/placeholder.png', 'photo')

              this.$store.dispatch('entities/fetchEntities')
            })
            .catch(err => {
              console.log(err)
              alert('Whoopsie! Ceva eroare la salvarea fisierului... (vezi in consola)')
            })
        })
        .catch(() => {})
    },
    async download (type) {
      let badPhotos = false
      try {
        await this.$dialog
          .confirm({
            title: 'Optiune download',
            body: 'Vrei sa descarci si pozele marcate ca fiind necorespunzatoare?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
        badPhotos = true
      } catch (e) {
        badPhotos = false
      }
      const data = this.selectedItems.length ? this.selectedItems.map(item => item._id) : this.items.map(item => item._id)
      this.$store.dispatch('dowloadZip', { type, photos: data, badPhotos })
        .then(res => {
          const fileStream = createWriteStream(`VerdeScoli_${slug(this.selectedLabel || 'Toate')}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)

          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
    },
    downloadPdfs (mode) {
      const data = this.selectedItems.length ? this.selectedItems.map(item => item._id) : this.items.map(item => item._id)
      this.$store.dispatch('dowloadPdfsZip', { mode, pdfs: data })
        .then(res => {
          const fileStream = createWriteStream(`VerdeScoli_${slug(this.selectedLabel || 'Toate')}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)

          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded (e) {
      if (!this.$refs.fileinput.files.length) return
      // this.$store.commit('setLoading', true)

      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(error => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
            alert('Whoops! Whoopsie! Ceva nu a functionat...')
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        // this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },
    toggleTab () {
      this.tab = this.tab === 'photos' ? 'pdfs' : 'photos'
      this.toDelete = []
    },

    _cbSelectDeletePdfProxy (itemId, pdf) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === pdf)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(pdf)
      } else {
        this.setSelectedPdf(itemId, pdf)
      }
    },
    setSelectedPdf (itemId, pdf) {
      this.selectedPdf = {
        id: itemId,
        pdf
      }

      this.pdfFrameSrc = this.serverURL + pdf + '?buster=' + new Date().getTime()
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
    },

    resetData (which) {
      this[`data${which}`] = null
    },

    showIfBadPhoto (photo) {
      if (this.tipPoze.includes('bad photos')) {
        return photo.includes('badphoto')
      } else {
        return !photo.includes('badphoto')
      }
    }
  },
  mounted () {
    if (this.searchTerm) {
      this.search = this.searchTerm
    }

    this.editor = new ImageEditor(document.querySelector('#editor'), {
      includeUI: {
        loadImage: {
          // path: this.serverURL + photo,
          path: this.serverURL + '/img/placeholder.png',
          // path: 'https://www.grouphealth.ca/wp-content/uploads/2018/05/placeholder-image-300x225.png',
          name: 'photo'
        },
        // initMenu: 'filter',
        menuBarPosition: 'bottom'
      },
      cssMaxWidth: 700,
      cssMaxHeight: 500,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70
      }
    })
  }
}
</script>

<style>
.components-container {
  position: relative;
  height: 100%;
}

.photo {
  box-sizing: border-box;
  border: 2px dashed #CFD8DC;
  border-radius: 100%;
  height: 48px;
  width: 48px;
  cursor: pointer;
}

.photo.delete-enabled {
  opacity: .55;
  border-color: var(--v-error-base);
  border-style: dashed;
}

.photo.toDelete {
  opacity: 1;
  border-style: solid;
}

.selected-photo {
  border-style: solid;
  border-color: var(--v-primary-base);
  font-weight: bold;
}

.selected-photo-simbol {
  color: var(--v-primary-base);
  font-weight: bold;
}

.tui-image-editor-header {
  /* visibility: hidden; */
  display: none;
}

.symbol {
  opacity: .55;
  border: 2px dashed #CFD8DC;
  border-radius: 100%;
  padding: 26px;
}

.opacity1 {
  opacity: 1 !important;
}

.symbol.selected-symbol{
  border-color: var(--v-primary-base);
  border-style: solid;
}
.symbol.delete-enabled{
  border-color: var(--v-error-base);
  border-style: dashed;
}
.symbol.toDelete{
  border-style: solid;
}
</style>
